import Model, { attr } from '@ember-data/model';

import type { DateRangeInterface, DSData } from 'webapp-types';

import type { AnnotationData } from 'webapp/models-custom/annotation';

export interface SampleData {
	dateRange: DateRangeInterface.FormulaInterface;
	dsData: DSData.RootTop[];
	timezone?: { timezone_type: number; timezone: string }; // BE's DateTimeZone as JSON
	annotations?: AnnotationData[];
	id?: string | number; // set to the block id for the previews of unsaved blocks (forecasts)
}

export default class SampleRecord extends Model {
	@attr('object') sampledata!: SampleData;
}
